'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoadingDots = require('UIComponents/loading/UILoadingDots');

var _UILoadingDots2 = _interopRequireDefault(_UILoadingDots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingState() {
  return _react2.default.createElement(
    'div',
    { style: { height: '100%' } },
    _react2.default.createElement(_UILoadingDots2.default, null)
  );
}

LoadingState.displayName = 'LoadingState';

exports.default = LoadingState;
module.exports = exports['default'];